var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-gm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h512v170.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170.7h512V199H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009",
    d: "M0 199.1h512V313H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 312.9h512v28.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M0 341.3h512V512H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGm);
export default __webpack_public_path__ + "static/media/gm.dfd25b88d3660d236c00fd9b79861dac.svg";
export { ForwardRef as ReactComponent };